import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() title: any;
  year: string;
  // @Input() year: any;
  constructor(
    private router: Router,
  ) { }

  ngOnInit() {}

  irInicio() {
    this.router.navigateByUrl('/');
    // this.navController.navigateRoot('inicio');
  }

  getYear(){
    var date = new Date();
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();

    if(Number(year) < 10){
      year = '0' + year;
    }
    if(Number(month) < 10){
      month = '0' + month;
    }
    if(Number(day) < 10){
      day = '0' + day;
    }

    return year
  }

}
